import p from "./FormControlledPassword.js";
import { t as e } from "i18next";
import * as s from "ramda";
import { useEffect as f } from "react";
import { jsx as n } from "react/jsx-runtime";
const w = (i) => {
  const {
    name: o,
    password: r,
    trigger: t,
    ...m
  } = i;
  return f(() => {
    !s.isEmpty(r) && !s.isNil(r) && t(o);
  }, [o, r, t]), /* @__PURE__ */ n(p, {
    ...m,
    name: o,
    type: "password",
    rules: {
      required: !0,
      validate: (a) => a === r
    },
    label: e("account_setting.confirm_password"),
    helperText: e("account_setting.confirm_password_error")
  });
};
export {
  w as default
};
//# sourceMappingURL=ConfirmPasswordTextField.js.map
